/**
 * Eventos globais para fluxo de auth que não dependem de um contexto React.
 *
 * P3 review 2026-09-24: substituídos pelo monkey-patch window.fetch que
 * existia em AuthContext. O AuthContext se inscreve em `unauthorized` aqui
 * via useEffect e faz logout/redirect quando qualquer fetch autenticado
 * recebe 401.
 */
export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export const authEvents = {
  unauthorized(url?: string) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT, { detail: { url } }));
  },
};

/** Resposta 402 da API: recurso fora do plano ou acesso bloqueado (teste encerrado, assinatura parada) */
export const PLAN_REQUIRED_EVENT = 'plan:required';

export interface PlanRequiredDetail {
  code?: string;
  message: string;
  requiredPlan?: string | null;
  feature?: string;
}

export const planEvents = {
  required(detail: PlanRequiredDetail) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent<PlanRequiredDetail>(PLAN_REQUIRED_EVENT, { detail }));
  },
};
